import type { QueryClient } from "@tanstack/react-query";

import { orpc } from "@/utils/orpc.client";

type LegacyRedirectEntity = "artist" | "release" | "work" | "company" | "label";

interface ResolveLegacyDiscogsCatalogIdInput {
  entity: LegacyRedirectEntity;
  id: string;
  queryClient: QueryClient;
}

export async function resolveLegacyDiscogsCatalogId({
  entity,
  id,
  queryClient,
}: ResolveLegacyDiscogsCatalogIdInput): Promise<string | null> {
  const { catalogId } = await queryClient.ensureQueryData(
    orpc.catalog.resolveLegacyId.queryOptions({
      input: {
        entity,
        namespace: "discogs",
        value: id,
      },
    }),
  );

  return catalogId && catalogId !== id ? catalogId : null;
}
